(() => {
  const PRODUCT_PRICE_SELECTOR = '[data-product-price]';
  const ADDON_PRICE_SELECTOR = '.mc-product__checkbox-price';
  const MONEY_MARKUP_RE = /^\s*<span\s+class=(?:["']?money["']?)\s*>([\s\S]*?)<\/span>\s*$/i;
  const ADDON_MONEY_RE = /^\s*\|\s*((?:GH₵|GHS)\s*[\d,.]+)\s*$/i;

  const repairPriceNode = (node) => {
    if (!(node instanceof HTMLElement)) return;

    const literalMarkup = (node.textContent || '').trim();
    if (!MONEY_MARKUP_RE.test(literalMarkup)) return;

    // The value comes from Shopify's trusted money formatter. Render the
    // wrapper as markup so BUCKS can see a real .money element instead of
    // the literal <span class=money> text produced by the custom product JS.
    node.innerHTML = literalMarkup;
  };

  const repairAddonPriceNode = (node) => {
    if (!(node instanceof HTMLElement)) return;
    if (node.querySelector('.money')) return;

    const label = (node.textContent || '').trim();
    const match = label.match(ADDON_MONEY_RE);
    if (!match) return;

    const money = document.createElement('span');
    money.className = 'money';
    money.textContent = match[1];

    node.replaceChildren(document.createTextNode('| '), money);
  };

  const repairAllPrices = (root = document) => {
    if (root instanceof HTMLElement && root.matches(PRODUCT_PRICE_SELECTOR)) {
      repairPriceNode(root);
    }
    if (root instanceof HTMLElement && root.matches(ADDON_PRICE_SELECTOR)) {
      repairAddonPriceNode(root);
    }

    root.querySelectorAll?.(PRODUCT_PRICE_SELECTOR).forEach(repairPriceNode);
    root.querySelectorAll?.(ADDON_PRICE_SELECTOR).forEach(repairAddonPriceNode);
  };

  const start = () => {
    repairAllPrices();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const target = mutation.target instanceof HTMLElement
          ? mutation.target
          : mutation.target.parentElement;

        const productPriceNode = target?.closest?.(PRODUCT_PRICE_SELECTOR);
        if (productPriceNode) repairPriceNode(productPriceNode);

        const addonPriceNode = target?.closest?.(ADDON_PRICE_SELECTOR);
        if (addonPriceNode) repairAddonPriceNode(addonPriceNode);

        mutation.addedNodes.forEach((addedNode) => {
          if (addedNode instanceof HTMLElement) repairAllPrices(addedNode);
        });
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    document.addEventListener('shopify:section:load', (event) => {
      repairAllPrices(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
